/* eslint-disable no-nested-ternary */
import {Box, CircularProgress, Toolbar} from '@mui/material'
import {React} from 'common'
import {BrowserView, MobileView} from 'react-device-detect'
import MainMenuButton from './MainMenuButton'
import MobileSideMenuButton from './Mobile/MobileSideMenuButton'
import Logo from 'components/Display/Logo'
import SearchArea from './SearchArea'
import LanguageMenuButton from './LanguageMenuButton'
import HeaderActions from './HeaderActions'
import Button from 'components/Control/Button.js'
import {useNavigate} from 'react-router-dom'
import {t} from 'i18n-js'
import useUserInfo from 'logic/Auth/useUserInfo.js'
import styled from 'styled-components'

const HeaderToolbar = ({
    dances,
    toggleDrawer,
    isLoading,
    isFlex,
    handleMobileSearchMenuOpen,
    handleMobileSideMenuOpen,
    isMobileSideMenuOpen,
    isMobileSearchMenuOpen,
    languageMenuId,
    handleLanguageMenuOpen,
    menuId,
    mobileMenuId,
    handleMobileMenuOpen,
    handleProfileMenuOpen,
    isSearchLoading,
}) => {
    const {
        isChoreographer,
        isLoggedIn,
        isLoading: isUserLoading,
    } = useUserInfo()

    const navigate = useNavigate()

    return (
        <>
            <Toolbar>
                <BrowserView>
                    <MainMenuButton toggleDrawer={toggleDrawer} />
                </BrowserView>

                <MobileView>
                    <MobileSideMenuButton
                        handleMobileSideMenuOpen={handleMobileSideMenuOpen}
                        // isFlex={isFlex}
                        // open={isMobileSideMenuOpen}
                    />
                </MobileView>
                <Box ml={'15px'}>
                    <Logo />
                </Box>
                <BrowserView>
                    <SearchArea
                        handleMobileSearchMenuOpen={handleMobileSearchMenuOpen}
                        isFlex={isFlex}
                        open={isMobileSearchMenuOpen}
                        dances={dances}
                        isLoading={isLoading || isSearchLoading}
                    />
                </BrowserView>
                <Box sx={{flexGrow: 1}} />

                {isUserLoading ? (
                    <StyledCircularProgress />
                ) : isLoggedIn ? (
                    <HeaderActions
                        menuId={menuId}
                        handleProfileMenuOpen={handleProfileMenuOpen}
                        isChoreographer={isChoreographer}
                    />
                ) : (
                    <Button
                        onClick={() => navigate('/login')}
                        variant="outlined">
                        {t('toolbar.signInSignUp')}
                    </Button>
                )}
                <Box mx={1}>
                    <LanguageMenuButton
                        menuId={languageMenuId}
                        handleLanguageMenuOpen={handleLanguageMenuOpen}
                    />
                </Box>
            </Toolbar>
            <MobileView>
                <Toolbar>
                    <SearchArea
                        handleMobileSearchMenuOpen={handleMobileSearchMenuOpen}
                        isFlex={isFlex}
                        open={isMobileSearchMenuOpen}
                        dances={dances}
                        isLoading={isLoading || isSearchLoading}
                    />
                </Toolbar>
            </MobileView>
        </>
    )
}

export default HeaderToolbar

const StyledCircularProgress = styled(CircularProgress)`
    color: green;
    width: 50px;
    height: 50px;
`
